import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '2020重庆春季线上旅游交易会';

const route: RouteConfig = {
  path: '/20200306CJH',
  name: '20200306CJH',
  component: () => import('./Home.vue'),
  redirect: '/20200306CJH/index',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'index',
      component: () => import('./First.vue'),
      name: '20200306CJH/index',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      component: () => import('./Detail.vue'),
      name: '20200306CJH/detail',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      component: () => import('./RelativeNews.vue'),
      name: '20200306CJH/news',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: '20200306CJH/rules',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
